import { Injectable, OnDestroy } from '@angular/core';

import { Subscription } from 'rxjs';

import { Account, SemantriaAccount } from 'app/providers/bridge-api/account.service';
import { Dashboard } from 'app/providers/bridge-api/dashboard.service';
import { EnableClassTelemetry } from 'app/services/otel.service';

@EnableClassTelemetry()
@Injectable({
  providedIn: 'root',
})
export class DashboardPageManagerService implements OnDestroy {
  account: Account;
  accountSub$: Subscription;

  constructor(private semantriaAccount: SemantriaAccount) {
    this.accountSub$ = this.semantriaAccount.sub.subscribe((account) => {
      this.account = account;
    });
  }

  public get maxPages(): number {
    return this.account?.limits.SPOTLIGHT_MAX_PAGES_PER_DASHBOARD || 5;
  }

  public get maxWidgetsPerPage(): number {
    return this.account?.limits.SPOTLIGHT_MAX_WIDGETS_PER_PAGE || 10;
  }

  public isWidgetCountOverTheLimit(dashboard: Dashboard, pageId: number) {
    return (
      dashboard.widgets.filter((w) => w.payload.page === pageId).length >= this.maxWidgetsPerPage
    );
  }

  ngOnDestroy(): void {
    this.accountSub$.unsubscribe();
  }
}
